// 1. OTEL CONFIG -> MUST BE FIRST
import "./otel-tracing";

// 2. Other imports
import React, { createElement } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@components/app";
import { Provider } from "react-redux";
import store from "@src/reducers/store";

export const renderReactApp = () => {
  // Clear the existing HTML content
  document.body.innerHTML =
    '<div id="app" style="height: 100vh; display: flex; flex-direction: column; flex-grow: 1;"></div>';

  // Render your React component instead
  const root = createRoot(document.getElementById("app")!);

  const ReduxedApp = () => (
    <Provider store={store}>
      <App />
    </Provider>
  );

  root.render(createElement(ReduxedApp));
};

renderReactApp();
